import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledUsePoints = styled.div<{
  $isHPDesktop?: boolean;
}>`
  ${rtl`
  .checkbox-label > label {
    font-size: ${(props: { $isHPDesktop?: boolean }) => (props.$isHPDesktop ? toRem(12) : toRem(14))};
    font-weight:${baseVariables.font.fontWeightRegular};
    padding-inline-start: ${toRem(26)};
    width: fit-content;
  }
  .checkbox-switch-wrapper {
    justify-content: space-between;
  }
  .adv-searchform > label{
    padding-left:${toRem(26)};    
    }
`}
`;
